import UpdateSalesCreditNote from "../../../../components/@documents/sales_credit_notes/UpdateSalesCreditNote";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function SalesCreditNoteUpdatePage() {

    return (
        <UpdateSalesCreditNote 
            routeType={routeTypes.admin}
        />
    )
}